import React from 'react';
import { FormattedMessage } from 'react-intl';

export default class InfoMessageEnd extends React.PureComponent {
  constructor(props) {
    super(props);

    // Инициализируем rating из пропсов при первой загрузке
    this.state = {
      rating: props.topic && props.topic.private && props.topic.private.rate || 0
    };

    this.handleStarClick = this.handleStarClick.bind(this);
  }

  // Когда в компонент приходят новые пропсы (например, при переключении чата),
  // проверяем, изменилось ли поле "rate" — если да, обновляем локальный стейт
  componentDidUpdate(prevProps) {
    const prevRate = prevProps.topic.private ? prevProps.topic.private.rate : 0;
    const newRate = this.props.topic.private ? this.props.topic.private.rate : 0;

    // Например, если поменялся сам объект topic или поле rate
    if (
      prevProps.topic.name !== this.props.topic.name || 
      prevRate !== newRate
    ) {
      this.setState({ rating: newRate || 0 });
    }
  }

  handleStarClick(starNumber) {
    //console.log(`Нажата звезда: ${starNumber}`);

    // Обновляем локальный стейт для немедленного выделения звёзд
    this.setState({ rating: starNumber });

    // Пример вызова setMeta для обновления рейтинга на бэкенде
    const topic = this.props.topic;
    if (topic) {
      const params = { private: { rate: starNumber } };
      topic.setMeta({ desc: params, attachments: null });
    }
  }

  render() {
    // Дополнительно можем вывести в консоль, что сейчас в props
    // console.log('Props rating:', this.props.topic.private.rate);

    if (!this.props.topic) {
      return
    }

    let maxSession = 10;
    if (this.props.topic && this.props.topic.private && this.props.topic.private.maxsession) {
      maxSession = this.props.topic.private.maxsession || 10;

    }

    return (
      <div className="card">
        {/* Если количество диалогов равно максимальному, показываем close_finish */}
        {this.props.topic &&  this.props.topic.public && this.props.topic.public.numdialog && this.props.topic.public.numdialog === maxSession && (
          <div>
            <FormattedMessage
              id="message.close_finish"
              defaultMessage="Loading..."
              description="Label"
            />
          </div>
        )}

        {/* Если количество диалогов ещё не достигло максимального, показываем close или nextrec */}
        {(
          (this.props.topic.public.numdialog &&
            this.props.topic.public.numdialog !== maxSession) ||
          (!this.props.topic.public.numdialog &&
            this.props.topic.public.closed === 1)
        ) && (
          <FormattedMessage
            id="message.close"
            defaultMessage="Loading..."
            description="Label"
          />
        )}
        
        {(this.props.topic.public.numdialog || (!this.props.topic.public.numdialog && this.props.topic.public.nexttopic)) &&
          <>
            <br/>
            <div>
              <FormattedMessage
                id="message.rate_app"
                defaultMessage="Loading..."
                description="Rate app request"
              />
              :
            </div>

            {/* Блок со звёздами */}
            <div>
              {[1, 2, 3, 4, 5].map((star) => {
                // Если номер звезды <= текущий локальный рейтинг, красим её в "gold"
                const starColor = star <= this.state.rating ? 'gold' : 'inherit';
                return (
                  <span
                    key={star}
                    style={{
                      cursor: 'pointer',
                      fontSize: '1.2em',
                      marginRight: '5px',
                      color: starColor
                    }}
                    onClick={() => this.handleStarClick(star)}
                  >
                    ★
                  </span>
                );
              })}
            </div>
          </> 
        }

        <br/>
        {this.props.topic.public.numdialog &&
          this.props.topic.public.numdialog >= 1 &&
          this.props.topic.public.numdialog < maxSession && (
            <FormattedMessage
              id="message.nextrec"
              defaultMessage="Loading..."
              description="Label"
            />
        )}
        {' '}

        {/* Ссылка для перехода к следующему диалогу */}
        {this.props.topic.public.nexttopic && (
          <a
            href="#"
            onClick={e => {
              e.preventDefault();
              this.props.onTopicSelected(this.props.topic.public.nexttopic);
            }}
          >
            <FormattedMessage
              id="message.nextdialog"
              defaultMessage="Go to the next dialog"
              description="Button"
            />
          </a>
        )}
      </div>
    );
  }
}
